<template>
    <ConfirmationModal
        :title="headerText"
        :progress="saving"
        yes="Deactivate"
        no="Cancel"
        v-bind="$attrs"
    >
        <div v-if="entities.length === 1">
            You are about to deactivate <span class="DeactivationConfirmationModal__deactivationDetails">{{ entities[0].contactEmail }}</span>. Please confirm you would like to deactivate this entity.
        </div>
        <div v-else-if="entities.length > 1">
            You are about to deactivate <span class="DeactivationConfirmationModal__deactivationDetails">{{ entities.length }} entities</span>. Please confirm you would like to deactivate these entities.
        </div>
    </ConfirmationModal>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';

    import ConfirmationModal from '@/components/confirmation-modal/ConfirmationModal.vue';

    @Component({
        components: {
            ConfirmationModal,
        },
    })
    export default class DeactivationConfirmationModal extends Vue {
        @Prop({ type: Boolean, default: false })
        private saving!: boolean;

        @Prop({ type: Array, default: () => [] })
        private entities!: Entity[];

        private get headerText() {
            return `Are you sure you want to deactivate ${this.entities.length > 1 ? 'selected entities' : 'this entity'}?`;
        }
    }
</script>
